import React from 'react';
import { Link, use } from 'react-router-dom';

export const PageNotFound = ({match}) => {
    return (
        <React.Fragment>
            <h1>404 - Page Not Found!</h1>
            <p>The page: <em>"{match.params.path}"</em> doesn't exist!</p>
            <button><Link to="/">Homepage</Link></button>
        </React.Fragment>
    )
}